var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    className: "svg-icon native icon-logo-sex",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2H3z",
    fill: "#8FD8F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H3c0 1.1.9 2 2 2h5v3l3-3a2 2 0 0 0 2-2z",
    fill: "#155397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#46A2D9",
    d: "M3 5h12v2H3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D6DB5",
    d: "M3 8h12v2H3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackExchange);
export default __webpack_public_path__ + "static/media/StackExchange.718ff891ba2eb60374e2afdb7a2f132b.svg";
export { ForwardRef as ReactComponent };